export const humanizeKind = (kind: CRM.ActivityKind): string => {
  switch (kind) {
    case 'supervised':
      return 'Encadrée';
    case 'canoe':
      return 'Canoë';
  }
};
